import React, { Component } from 'react'
import './device-exception.less';
import dayjs from 'dayjs';
import { deviceException } from '@/interface/exception';
import { inject, observer } from 'mobx-react';
import UserStore from '@/store/user-store';
import { UserTypeEnum } from '@/routes/login/login';
import { message, Modal } from 'antd';
import { publishException } from '@/config/api/exception';
const { confirm } = Modal;
interface IProps {
    deviceExceptions?: deviceException[],
    userStore?: UserStore
}

@inject('userStore')
@observer
export default class DeviceException extends Component<IProps> {

    
    
    componentDidMount() {
        let userType = this.props.userStore._userInfo?.type;
        console.log(userType)
    }

    onPublishClick = (value: deviceException) => {
        let userType = this.props.userStore._userInfo?.type;
        if (!!userType && (userType === UserTypeEnum.ROOT || userType === UserTypeEnum.ADMIN)) {
            confirm({
                title: '确认发布设备报警？',
                onOk: () => {
                    console.log("aaa")
                    publishException(value.id, {
                        project_id: value.project_id
                    }).then(res => {
                        if (!!res.data)
                            message.success('报警发布成功');
                    })
                    // this.onPublishClick(value)
                },
                onCancel() {

                },
            })
        }
    }

    onPublishConfirm = (value: deviceException) => {
        publishException(value.id, {
            project_id: value.project_id
        }).then(res => {
            if (!!res.data)
                message.success('报警发布成功');
        })
    }

    render() {
        return (
            <div className="device-exception-container">
                <div className="title">异常信息</div>
                <div className="content">
                    {this.props.deviceExceptions.map((item, index) => (
                        <div className="exception-item" key={index} onClick={() => {
                            this.onPublishClick(item)
                        }}>
                            <div className='item-content ellipsis-span'>{item.content}</div>
                            <div className='item-time'>{dayjs(item.create_time).format('MM-DD HH:mm')}</div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}
